module.exports = __webpack_public_path__ + "img/anquan.87dd37dc.svg";